import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import { Dispatcher, Events, Actions } from '../../flux';
import { Logo } from '../';

import './Header.scss';

class Header extends Component {
  state = {
    intern: false,
  };

  componentDidMount = () => {
    // Get the header
    this.header = document.getElementById('siteHeader');

    // Get the offset position of the navbar
    this.sticky = this.header.offsetTop + 100;

    // Run Scroll if is Homepage
    window.onscroll = () => this.runScroll();
  };

  componentWillMount = () => {
    Dispatcher.on(Events.HEADER_INTERN, this.headerIntern.bind(this));
    Dispatcher.on(Events.HEADER_HOME, this.headerHome.bind(this));
  };

  componentWillUnmount = () => {
    Dispatcher.removeListener(Events.HEADER_INTERN, this.headerIntern);
    Dispatcher.removeListener(Events.HEADER_HOME, this.headerHome);
  };

  toggleMenu = () => {
    const { menuClicked } = this.props;
    if (typeof menuClicked === 'function') menuClicked();
  };

  headerIntern = () => {
    this.setState({ intern: true });
  };

  headerHome = () => {
    this.setState({ intern: false });
    this.header.classList.add('site-header--sticky');
  };

  runScroll = () => {
    const { intern } = this.state;
    if (intern) {
      this.header.classList.add('site-header--sticky');
      return;
    }

    if (window.pageYOffset > this.sticky) {
      this.header.classList.add('site-header--sticky');
    } else {
      // this.header.classList.remove('site-header--sticky');
    }
  };

  render = () => {
    const { menuClicked, idMenu } = this.props;
    const { intern } = this.state;
    let classes = ['site-header', 'container-fluid', intern || !idMenu ? 'site-header--sticky' : ''];
    return (
      <header className={classes.join(' ')} id={idMenu}>
        <div className="container">
          <div className="row">
            <div className="col-6 logo-column">
              <Logo menuNome={idMenu} eventoMenu={menuClicked} />
            </div>
            <div className="col-6 hamburger-column">
              {typeof menuClicked === 'function' && (
                <div className="hamburger-handler" onClick={() => menuClicked()}>
                  {!!idMenu
                    ? renderHTML(`<svg
                    data-name="Interface-Essential / Menu / navigation-menu-1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.143"
                    height="18"
                  >
                    <g fill="#fff">
                      <path d="M0 1.5A1.507 1.507 0 011.512 0h15.12a1.507 1.507 0 011.512 1.5v1A1.507 1.507 0 0116.632 4H1.512A1.507 1.507 0 010 2.5zM0 8.5A1.507 1.507 0 011.512 7h15.12a1.507 1.507 0 011.512 1.5v1a1.507 1.507 0 01-1.512 1.5H1.512A1.507 1.507 0 010 9.5zM0 15.5A1.507 1.507 0 011.512 14h15.12a1.507 1.507 0 011.512 1.5v1a1.507 1.507 0 01-1.512 1.5H1.512A1.507 1.507 0 010 16.5z" />
                    </g>
                  </svg>`)
                    : renderHTML(`<svg viewBox="0 0 15.66 15.661" xmlns="http://www.w3.org/2000/svg" width="18.143" height="18">
                    <g transform="translate(-3.243 -2.169)">
                      <g fill="#6e6e6e">
                        <path
                          transform="translate(-385.67 -116.52) rotate(-45)"
                          d="M182,369.5a1.507,1.507,0,0,1,1.512-1.5h15.12a1.507,1.507,0,0,1,1.512,1.5v1a1.507,1.507,0,0,1-1.512,1.5h-15.12A1.507,1.507,0,0,1,182,370.5Z"
                        />
                        <path
                          transform="translate(-125.35 416.64) rotate(225)"
                          d="M182,383.5a1.507,1.507,0,0,1,1.512-1.5h15.12a1.507,1.507,0,0,1,1.512,1.5v1a1.507,1.507,0,0,1-1.512,1.5h-15.12A1.507,1.507,0,0,1,182,384.5Z"
                        />
                      </g>
                    </g>
                  </svg>`)}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    );
  };
}

export { Header };
